module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-42.6441962c.png";